import { useState, useEffect } from 'react'
import moment from 'moment';
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { backendDateFormat, fieldDateFormat } from '../../../../constants';
import { regexConstants } from '../../../../constants/regEx';
import { checkApiStatus, numberWithCommas } from '../../../../utils'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AttachementsUpload } from '../../../../shared_elements/components';
import { addSecurityDepositApi, updateSecurityDepositApi, getSecurityAgainstDropApi } from '../apiService';
import { globalPostService, globalPutService, globalGetService } from '../../../../utils/globalApiServices';
import InfoIcon from '@mui/icons-material/Info';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Autocomplete, FormControlLabel, Checkbox, Tooltip, Box, Link, TableHead, TableRow, TableCell, Table, TableBody, Typography, FormGroup } from '@mui/material';
import { PageLoader } from '../../../../shared_elements';
import { setFileUploadDetails } from '../../../../shared_elements/actions';
import { trackActivity } from '../../../../utils/mixpanel';
import { formatBytes } from '../../../../utils/fileUpload';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';

const SecurityDepositCRU = ({ securityDepositCRU, fileUpload, modeType, getResponseBack, onToggleModal, onOpenAttachments, sdcData }) => {
    const dispatch=useDispatch()
    const navigate=useNavigate();
    const { storageDetails } = useSelector((state) => state.leases); 
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug };
    const { enqueueSnackbar } = useSnackbar();
    const [data, setData] = useState(securityDepositCRU?.data);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const [cleared, setCleared] = useState(false);
    const [attachments, setAttachments] = useState([]);
    const [securityAgainstApi, setSecurityAgainstApi] = useState([]);
    const [dropDownLoader,setDropDownLoader]=useState(false)
    const { leaseBasicDetails } = useSelector((state) => state.leases);
    const [securityDepositTableData,setSecurityDepositTableData] = useState([]);
    const securityCRUTable = [];
    // if (securityDepositTableData?.list?.length > 0) {
    //     securityDepositTableData.list.map((item, i) => {
    //         securityCRUTable.push({ id: item?.id, label: item?.name, base_key: `${item?.id}_base_amount`, contractual_key: `${item?.id}_contractual_amount` })
    //     })
    // }

    useEffect(() => {
        if (!sdcData?.base_currency) {
            setData((prev) => ({
                ...prev,
                base_amount: null
            }));
        }
    }, [sdcData?.base_currency]);

    useEffect(() => {
        getSDAgainstDropdown()
        if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false);
            }, 1500);
            return () => clearTimeout(timeout);
        }
        return () => { };
    }, [])

    const handleFileChange = (files) => {
        setAttachments(files);
         dispatch(setFileUploadDetails({attachments:files}))
    };

    const getSDAgainstDropdown = () => {
        setDropDownLoader(true)
        globalGetService(getSecurityAgainstDropApi())
            .then(response => {
                setDropDownLoader(false)
                if (checkApiStatus(response)) {
                    setSecurityAgainstApi(response?.data?.data?.list);
                }
            })
    }

    const onFieldChange = (keyParam, value) => {
        if (keyParam === "security_deposit_type" && !value) {
            setData({ ...data, 'security_deposit_type': null, "is_refundable": false, "is_repaying_with_interest": false, "interest_rate_percentage": null });

        } else if (keyParam === "security_deposit_type" && value?.label === "Letter of Credit") {
            setData({ ...data, "security_deposit_type": value, "is_refundable": false, "is_repaying_with_interest": false, "interest_rate_percentage": null, });

        } else if (keyParam === "is_refundable" && !value) {
            setData({ ...data, "is_refundable": false, "is_repaying_with_interest": false, "interest_rate_percentage": null });
        } 
        else if (keyParam === "security_deposit_against_id") {
            setData({ ...data, [keyParam]: value, "security_deposit_against": value?.id });
        }
        else {
            setData({ ...data, [keyParam]: value });
        }
    }
    const onRestErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }


    const onAddEditSecurityDeposit = () => {
        let validationInputs = {};
        validationInputs = {
            security_deposit_type: data?.security_deposit_type?.value ? "" : "Please select Security Deposit Type",
            security_deposit_against_id: data?.security_deposit_against_id?.name ? "" : "Please select Security Against",
            interest_rate_percentage: data?.interest_rate_percentage ? "" : data?.is_repaying_with_interest && data?.is_refundable ? "Please enter Interest Rate Percentage" : '',
            contractual_amount: data?.contractual_amount ? "" : "Please enter Contractual Amount",
        };
        const dueDate = moment(data?.due_date);
        if(data.due_date && !dueDate.isValid()) {
            validationInputs.due_date = "Please enter valid Due Date"
        }
         
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            let payload = Object.assign({}, data);
            payload = {
                ...payload,
                base_amount: sdcData?.base_currency ? data?.base_amount ? data?.base_amount : null : null
            }
            if (data?.id) {
                globalPutService(updateSecurityDepositApi({ ...params, slug: data?.slug }), payload)
                    .then((response) => {
                        if (checkApiStatus(response)) {
                            if (attachments?.length) {
                                fileUpload(data?.slug,'','updated')
                            }
                            setLoading(false);
                            onToggleModal();
                            getResponseBack();
                            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Security Deposit`, success_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                        } else {
                            setLoading(false);
                            enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Security Deposit`, error_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                        }
                    })
            } else {
                globalPostService(addSecurityDepositApi(params), payload).then((response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(response?.data?.data?.slug,'','created')
                        }
                        setLoading(false);
                        onToggleModal();
                        getResponseBack();
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Security Deposit`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Security Deposit`, error_msg: response?.data?.message, item_id: null, payload: data, response: response?.data })
                    }
                })
            }
        } else {
            setError(validationInputs)
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Security Deposit`, error_msg: validationInputs, })
        }
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Security Deposit`, page_type: page_type, })
    }
   
    return (
        <>
            <Dialog
                aria-labelledby="customized-dialog-title"
                className='add-lease-dialog'
                maxWidth="md"
                fullWidth
                open={true}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} style={{ position: 'sticky' }} className='dialog-header'>
                    <Typography sx={{ marginLeft: '10px' }}>
                        {modeType === "add" ? "Add Security Deposit" : modeType === "edit" ? "Edit Security Deposit" : "View Security Deposit"}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                options={[{ label: "Cash Only", value: 1 }, { label: "Letter of Credit", value: 2 }]}
                                getOptionLabel={(option) => option?.label || ""}
                                value={data?.security_deposit_type || null}
                                disabled={modeType !== 'add'}
                                onFocus={() => onRestErrorKey("security_deposit_type")}
                                onChange={(e, value) => onFieldChange("security_deposit_type", value)}
                                noOptionsText={ modeType !== "view" && dropDownLoader?.security_deposit_type ? "Loading..." : "No Option Available" }
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                            <TextField
                                                {...params}
                                                label="Security Deposit Type"
                                                margin='normal'
                                                size='small'
                                                required
                                                error={!!error.security_deposit_type}
                                                helperText={error.security_deposit_type}
                                                slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{!(modeType === "view" || modeType === "edit") && dropDownLoader && ( <CircularProgress color="inherit" size={20} /> )} {params?.InputProps?.endAdornment} </>) } }}
                                            /></Tooltip>)
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                options={securityAgainstApi || []}
                                getOptionLabel={(option) => option?.name || ""}
                                disabled={modeType === 'view'}
                                noOptionsText={dropDownLoader ? "Loading..." : <Link onClick={() => navigate(`/settings/security-against`)} sx={{ textDecoration: "none", cursor: "pointer" }} >+ Add New Security Against</Link> }
                                value={data?.security_deposit_against_id || null}
                                onFocus={() => onRestErrorKey("security_deposit_against_id")}
                                onChange={(e, value) => onFieldChange("security_deposit_against_id", value)}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                    <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow > <TextField
                                        {...params}
                                        label={
                                            <span style={{ verticalAlign: 'super' }}>
                                                Security Against
                                                <Tooltip placement='right' title={<span>Please add Security Against Data in Settings </span>} arrow>
                                                    <InfoIcon fontSize='small' color='primary' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                </Tooltip>
                                            </span>
                                        }
                                        margin='normal'
                                        size='small'
                                        required
                                        error={!!error.security_deposit_against_id}
                                        helperText={error.security_deposit_against_id}
                                        slotProps={{ inputLabel: { shrink: true } , input:{ ...params?.InputProps,endAdornment: (<>{modeType !== "view" && dropDownLoader && ( <CircularProgress color="inherit" size={20} /> )}{params?.InputProps?.endAdornment} </> ) }} }
                                    />
                                </Tooltip>)}}
                            />
                        </Grid>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <TextField
                                required
                                id="contractual_amount"
                                label="Contractual Amount"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                error={error?.contractual_amount || false}
                                helperText={error?.contractual_amount || ''}
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={modeType === "view" && data?.contractual_amount !== '' && data?.contractual_amount !== null && data?.contractual_amount !== undefined ? numberWithCommas(data?.contractual_amount) : (data?.contractual_amount ? data?.contractual_amount : "")}
                                onChange={(e) => {
                                    let val = e.target.value;
                                    if (val === "") {
                                        onFieldChange("contractual_amount", "");
                                        return;
                                    }
                                    if (val.length <= 20 && regexConstants.decimalnodotstart.test(val)) {
                                        onFieldChange("contractual_amount", val);
                                    }
                                }}
                                onFocus={() => onRestErrorKey("contractual_amount")}
                            />
                        </Grid>
                        {sdcData?.base_currency &&
                        <Grid size={{ md: 6, xs: 12 }}>
                            <TextField
                                id="base_amount"
                                label="Base Amount"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={modeType === "view" && data?.base_amount !== '' && data?.base_amount !== null && data?.base_amount !== undefined ? numberWithCommas(data?.base_amount) : (data?.base_amount || "")}
                                onChange={(e) => {
                                    let val = e.target.value;
                                    if (val === "") {
                                        onFieldChange("base_amount", "");
                                        return;
                                    }
                                    if (val.length <= 20 && regexConstants.decimalnodotstart.test(val)) {
                                        onFieldChange("base_amount", val);
                                    }
                                }}
                            />
                        </Grid>}
                        
                        <Grid size={{ md: 6, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Due Date"
                                    minDate={moment(leaseBasicDetails?.start_date)}
                                    maxDate={moment(leaseBasicDetails?.end_date)}
                                    value={data?.due_date ? moment(data?.due_date) : null}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        onFieldChange("due_date", data ? moment(data).format(backendDateFormat) : null);
                                        if (isValid) {
                                            onRestErrorKey("due_date");
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.due_date || false,
                                            helperText: error.due_date || '',
                                            onFocus: () => {error.due_date && onRestErrorKey("due_date");}
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => { onFieldChange("due_date", null); setCleared(true); onRestErrorKey("due_date") }
                                        },
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />
                            </LocalizationProvider>
                        </Grid>
                        {data?.security_deposit_type?.value === 1 ? <Grid size={{ md: 6, xs: 12 }}>
                            <FormControlLabel sx={{ margin: '0px', cursor: modeType === "view" && "not-allowed" }} control={
                                <Checkbox
                                    disabled={modeType === 'view'}
                                    checked={data?.is_refundable ? true : false}
                                    onChange={(e) => onFieldChange('is_refundable', e.target.checked)}
                                    color="primary"
                                    size="small" />}
                                label="Security Deposit Refundable"
                            />
                        </Grid> : null}
                        {data?.is_refundable ? <Grid size={{ md: 6, xs: 12 }}>
                            <FormControlLabel sx={{ margin: '0px', cursor: modeType === "view" && "not-allowed"  }} control={
                                <Checkbox
                                    disabled={modeType === 'view'}
                                    checked={data?.is_repaying_with_interest ? true : false}
                                    onChange={(e) => onFieldChange('is_repaying_with_interest', e.target.checked)}
                                    color="primary"
                                    size="small" />}
                                label="Is SD Repaying with interest"
                            />
                        </Grid> : null}
                        {data?.is_repaying_with_interest && data?.is_refundable ? <Grid size={{ md: 6, xs: 12 }}>
                            <TextField
                                required
                                id="interest_rate_percentage"
                                label="Interest Rate Percentage"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                error={error?.interest_rate_percentage || false}
                                helperText={error?.interest_rate_percentage || ''}
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={data?.interest_rate_percentage || ""}
                                onChange={(e) => { regexConstants.percantageRegExp.test(e.target.value) ? onFieldChange('interest_rate_percentage', e.target.value ? e.target.value : null) : e.preventDefault() }}
                                onFocus={() => onRestErrorKey("interest_rate_percentage")}
                            />
                        </Grid> : null}
                        <Grid size={{ xs: 12, md: 12 }}>
                            <FormGroup className='disabled-checkbox-wrapper'>
                                <Box className="check-item-div" sx={{cursor: modeType === "view" && "not-allowed"}}>
                                    <Checkbox  checked={data?.convert_cash_lc? true:false} onChange={(e)=> onFieldChange('convert_cash_lc',e.target.checked)} disabled={modeType === 'view'} />
                                    <Typography className="check-item-span" fontSize='14px'>Convert Cash to LC</Typography>
                                </Box>
                            </FormGroup>
                        </Grid>
                        {/* {securityDepositTableData?.list?.length > 0 ?
                            <Grid size={{ md: 12, xs: 12 }}>
                                <Table className="mui-table-format">
                                    <TableHead >
                                        <TableRow>
                                            <TableCell sx={{ minWidth: '150px' }}></TableCell>
                                            <TableCell>Base Amount(USD) </TableCell>
                                            <TableCell>Contratual Amount(USD) </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {securityCRUTable.map((tableItem, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell className="table-actions-list" align='center'>{tableItem.label}</TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            id={tableItem.base_key}
                                                            margin='normal'
                                                            size='small'
                                                            variant="outlined"
                                                            value={data?.[tableItem.base_key] ? data?.[tableItem.base_key] : ""}
                                                            onChange={(e) => { if (e.target.value === "" || regexConstants?.numberWithDot.test(e.target.value)) onFieldChange(tableItem.base_key, e.target.value) }}
                                                            fullWidth
                                                            disabled={modeType === "view"}
                                                            slotProps={{ htmlInput: { maxLength: 20 } }}
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            id={tableItem.contractual_key}
                                                            margin='normal'
                                                            size='small'
                                                            variant="outlined"
                                                            value={data?.[tableItem.contractual_key] ? data?.[tableItem.contractual_key] : ""}
                                                            onChange={(e) => { if (e.target.value === "" || regexConstants?.numberWithDot.test(e.target.value)) onFieldChange(tableItem.contractual_key, e.target.value) }}
                                                            fullWidth
                                                            disabled={modeType === "view"}
                                                            slotProps={{ htmlInput: { maxLength: 20 } }}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </Grid>
                            : null} */}
                        {modeType === 'view' ?
                            <Grid item size={{ md: 12, xs: 12 }}>
                                <LessMoreTextFieldComp label='Remarks' value={data?.remarks || ""} />
                            </Grid>
                            : <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    rows={3}
                                    id="remarks"
                                    label="Remarks"
                                    variant="outlined"
                                    size="small"
                                    margin="normal"
                                    value={data?.remarks || ""}
                                    fullWidth
                                    multiline
                                    disabled={modeType === "view"}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("remarks", e.target.value.trimStart()) : e.preventDefault()
                                        setError(prev => ({ ...prev, remarks: "" }));
                                    }} 
                                />
                            </Grid>}
                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>
                            <Box className="responsive-buttons">
                             {data?.id && data?.attachments?.length ? <Button onClick={() => { onOpenAttachments(); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>({securityDepositCRU?.data?.attachments?.length})Attachment(s)</Button> : null}
                              <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                            </Box>
                            {modeType === 'view' ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={data?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className='cancel-btn' disabled={isLoading} variant="outlined" size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }} >{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null :
                        <Button variant="contained" size='small' className="btn-primary" onClick={() => { handleItemClicked('Save Button'); onAddEditSecurityDeposit() }}> {isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"} </Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
        </>
    )
}

export default SecurityDepositCRU